import instance from "../xhrService";

export type TemplatePriorityOptionType = {
  label: string;
  order: number;
  template_id: number;
};

const baseUrl = () => `/api/template-priority-options`;

export const templatePriorityOptionsApi = {
  /**
   * Fetch all priority options for a given template
   */
  getByTemplateId: (templateId: number) =>
    instance
      .get(`${baseUrl()}/${templateId}`)
      .then((res) => res.data),

  /**
   * Replace all options for a given template
   */
  update: (templateId: number, options: TemplatePriorityOptionType[]) =>
    instance
      .post(`${baseUrl()}/update`, {
        templateId,
        options,
      })
      .then((res) => res.data),
};

export default templatePriorityOptionsApi;
